import React, { useState } from 'react'
import './index.scss'
import { IoIosArrowDown } from 'react-icons/io'

type OrderType = any

type ColumnOption = {
    label: string
    value: string
}

interface TableSortFilterProps {
    currentSortField: string
    currentSortType: OrderType
    onSortChange: (field: string, sortType: OrderType) => void
    columnOptions: ColumnOption[]
}

export const TableSortFilter: React.FC<TableSortFilterProps> = ({
    currentSortField,
    currentSortType,
    onSortChange,
    columnOptions,
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedField, setSelectedField] = useState(currentSortField)
    const [selectedOrder, setSelectedOrder] =
        useState<OrderType>(currentSortType)

    const toggleOpen = () => setIsOpen((prev) => !prev)

    const applyFilters = () => {
        onSortChange(selectedField, selectedOrder)
        setIsOpen(false)
    }

    const resetFilters = () => {
        setSelectedField('taxa_vitoria')
        setSelectedOrder('desc')
        onSortChange('taxa_vitoria', 'desc')
    }

    return (
        <div className="table-sort-filter">
            <button className="sort-button" onClick={toggleOpen}>
                Ordenar
                <span className={`arrow ${isOpen ? 'open' : ''}`}>
                    <IoIosArrowDown size={20} />
                </span>
            </button>

            {isOpen && (
                <div className="filter-popup">
                    <div className="filter-header">
                        <span>Filtrar por:</span>
                        <button className="reset-btn" onClick={resetFilters}>
                            Redefinir filtros
                        </button>
                    </div>

                    <div className="section">
                        <span className="label">Ordem</span>
                        <div className="options">
                            <button
                                className={`option ${
                                    selectedOrder === 'asc' ? 'active' : ''
                                }`}
                                onClick={() => setSelectedOrder('asc')}
                            >
                                Crescente
                            </button>
                            <button
                                className={`option ${
                                    selectedOrder === 'desc' ? 'active' : ''
                                }`}
                                onClick={() => setSelectedOrder('desc')}
                            >
                                Decrescente
                            </button>
                        </div>
                    </div>

                    <div className="section">
                        <span className="label">Coluna</span>
                        <select
                            className="select"
                            value={selectedField}
                            onChange={(e) => setSelectedField(e.target.value)}
                        >
                            {columnOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button className="apply-btn" onClick={applyFilters}>
                        Aplicar
                    </button>
                </div>
            )}
        </div>
    )
}
